// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"62a38929","977":"93f842fc"}[chunkId] + ".chunk.js";
};